import ReleaseNotesContainer from "./ReleaseNotesContainer";

export default ReleaseNotesContainer;
